import axios from 'axios';
import { AULA_ASSIGNMENTS } from '../../constants/endpoints';
import { getHeaders } from './utils';

type HomeUpcomingAssignment = {
  id: string;
  title: string;
  dueDate: string | null;
  startDate?: string;
  spaceId: string;
  courseName: string;
  role: 'educator' | 'student';
  status: 'Upcoming' | 'DueSoon' | 'Open';
  isSubmitted: boolean;
  isHidden: boolean;
  parentAssignmentId?: string;
  provider?: string;
  externalId?: string;
  providerId?: string;
  resourceLinkId?: string;
  cta: { label: string | null; path: string | null; disabled: boolean };
};

export type { HomeUpcomingAssignment };

export type HomeUpcomingAssignmentCount = {
  assignmentStatus: 'dueSoon' | 'upcoming' | 'open';
  count: number;
};

export type FetchHomeUpcomingAssignmentsResponse = {
  upcomingAssignments: HomeUpcomingAssignment[];
  page: number;
  limit: number;
  total: number;
  assignmentCounts?: HomeUpcomingAssignmentCount[];
};

export const fetchHomeUpcomingAssignments = async ({
  accessToken,
  limit = 5,
  page = 0,
  includeSubmitted = true,
  role,
  count = false,
}: {
  accessToken: string;
  limit?: number;
  page?: number;
  includeSubmitted?: boolean;
  role?: 'educator' | 'student';
  count?: boolean;
}) =>
  axios.get<FetchHomeUpcomingAssignmentsResponse>(
    `${AULA_ASSIGNMENTS()}/home/upcoming-assignments`,
    {
      params: {
        limit,
        page,
        includeSubmitted: String(includeSubmitted),
        ...(role ? { role } : {}),
        ...(count ? { count: 'true' } : {}),
      },
      headers: getHeaders(accessToken),
    }
  );
